module.exports = __webpack_public_path__ + "img/normal_stable.89b71b16.jpg";